import moment from 'moment'

const mobileExp =
  /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i

export default {
  methods: {
    formatDate(date) {
      return moment(date).format(`YYYY-MM-DD | HH:mm:ss`)
    },
    moveToPage(route, fn, isNewTab) {
      if (fn) fn()
      if (isNewTab) window.open(route)
      else this.$router.push(route)
    },
    close() {
      this.$emit('update:visible', false)
      console.log('global', this.visible)
      this.$emit('close')
    },
    routePush(Nm) {
      this.$router.push(Nm)
    },
    isMobileDevice() {
      const userAgent = navigator.userAgent.toLowerCase() || ''
      if (mobileExp.test(userAgent)) return 'MOBILE'
      else return 'PC'
    },
    errToast(txt) {
      this.$toasted.error(txt)
    },
    handleResize() {
      this.window.width = window.innerWidth
      this.window.height = window.innerHeight
    },
  },
  watch: {
    window: {
      deep: true,
      handler() {
        if (this.window.width < 1023) {
          this.isWidth = false
        } else {
          this.isWidth = true
        }
      },
    },
  },
  computed: {
    routeNm() {
      switch (this.$route.name) {
        case 'CEOGreeting':
        case 'corpIdeology':
        case 'History':
        case 'Organization':
        case 'FindWay':
          return 'CompIntroduc'

        case 'faciMana':
        case 'logiMana':
        case 'secuMana':
        case 'admiMana':
        case 'hotelMana':
          return 'BusinessArea'

        case 'HotelsNResorts':
        case 'DepartmentStore':
        case 'Distribution':
        case 'perfEtc':
          return 'Performance'

        case 'Personnel':
          return 'Recruitment'

        case 'NewNotice':
        case 'ReferenceRoom':
          return 'CustomerService'
      }
    },
    routeName() {
      return this.$route.name
    },
    isMobile() {
      if (this.isMobileDevice() === 'MOBILE') return true
    },
    isPc() {
      if (this.isMobileDevice() === 'PC') return true
    },
  },
}
